var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowMinimize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.655 9.77887C20.8782 9.58513 21 9.33855 21 9.04795C21 8.46673 20.4724 8 19.8027 8C19.4679 8 19.1635 8.12329 18.9301 8.32583L11.9899 14.4902L5.0699 8.32583C4.83653 8.12329 4.52198 8 4.19729 8C3.52762 8 3 8.46673 3 9.04795C3 9.33855 3.12176 9.58513 3.34498 9.77887L11.0564 16.6301C11.3202 16.8767 11.6449 16.9912 12 17C12.3551 17 12.6595 16.8767 12.9335 16.6301L20.655 9.77887Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMinimize);
export default __webpack_public_path__ + "static/media/arrow-minimize.4fc34feebcda2083d980976f20507e81.svg";
export { ForwardRef as ReactComponent };